import React from 'react';

const ConnectorContext = React.createContext(null);

export const ConnectorProvider = ({ connector, children }) => (
  <ConnectorContext.Provider value={connector}>
    {children}
  </ConnectorContext.Provider>
);

export const useConnector = () => React.useContext(ConnectorContext);
